import React, { useState, useEffect } from 'react'
import {
  Input,
  Grid,
  Row,
  Col,
  Panel,
  RadioGroup,
  Radio,
  IconButton,
  Icon,
  Form,
  FormGroup,
  ControlLabel,
  Modal,
  Button,
  Message,
} from 'rsuite'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { cloneDeep } from 'lodash-es'
import { isRequired, isValidators, isRequiredFiled } from '../../utils/ValidatorUtils'
import ActivityAddEditWidget from './ActivityAddEditWidget'
import scrollToComponent from 'react-scroll-to-component'
import CKEditorBlankFrom from '../../components/forms/input/CKEditorBlankFrom'

export default function ProgessActivityForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSuccess,
  onDelete,
  ...props
}) {
  const [schema, setSchema] = useState(_schema)
  const [isAdd, setIsAdd] = useState(false)
  const [activity, setActivity] = useState('')
  const [detail, setDetail] = useState('')
  const [editIndex, setEditIndex] = useState(-1)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isSaveError, setIsSaveError] = useState(false)
  const [editData, setEditData] = useState()
  const [section, setSection] = useState()
  const [isdelete, setIsdelete] = useState(false)
  const [deleteData, setDeleteData] = useState()
  const [deleteIndex, setDeleteIndex] = useState()

  useEffect(() => {
    setSchema(_schema)
  }, [_schema])

  const onAddSuccess = (e) => {
    setSchema(e)
    onSuccess(e)
  }

  const onClickDelete = (e, index) => {
    console.log('onClickDelete', e)
    setIsdelete(true)
    setDeleteIndex(index)
    setDeleteData(e)
  }

  const onClickEdit = (e) => {
    console.log('onClickEdit', e)
    setEditData(e)
    scrollToComponent(section, { offset: -50, align: 'top', duration: 500 })
  }

  return (
    <div
      ref={(section) => {
        setSection(section)
      }}
    >
      {/*้ซ่อนปุ่มเพิ่มกิจกรรม*/}
      {/* <ActivityAddEditWidget 
        schema={schema} 
        onAddSuccess={(e) => onAddSuccess(e)} 
        editData={editData} 
        /> */}
      <Message
        showIcon
        type="info"
        description={'หากต้องการแก้ไข/ปรับเปลี่ยนกิจกรรม ให้ดำเนินการแก้ไขสัญญา'}
      />

      <Grid fluid>
        {schema?.values?.map((item, index) => {
          console.log(index, '------', item)
          let objSchema = {
            name: item?.id,
            label: null,
            value: item?.result || null,
            validators: item?.validators || [],
          }

          return (
            <div key={index}>
              <Row style={{ marginTop: 10, marginBottom: 5 }}>
                <p>
                  <b>
                    {'กิจกรรมที่ ' + (index + 1)} {item.activity}
                  </b>
                </p>
                <p>&nbsp;&nbsp;&nbsp;&nbsp;{item.activityDetail}</p>

                {console.log('item ', index, ' ', item)}

                <ErrorMessage error={errors[item.id]} />
                <ControlLabel>
                  {isRequiredFiled(isRequired(item.validators), item.resultLabel)}
                </ControlLabel>

                <CKEditorBlankFrom
                  schema={objSchema}
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                  hideToolbar={true}
                />
                {/* <Input
                  disabled={isAdd}
                  componentClass="textarea"
                  rows={3}
                  name={item.id}
                  defaultValue={item.result}
                  inputRef={register(isValidators(item.validators))}
                  placeholder={item.hint}
                /> */}
              </Row>

              {item.enableDelete && (
                <div>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-edit"
                    icon={
                      <Icon appearance="ghost" icon="edit" className="bt-gost-icon-radius-edit" />
                    }
                    onClick={() => onClickEdit(item)}
                    style={{ marginRight: 5 }}
                  >
                    {'แก้ไขกิจกรรมที่ ' + (index + 1)}
                  </IconButton>
                  <IconButton
                    appearance="ghost"
                    className="rs-btn-ghost-cancel"
                    icon={
                      <Icon
                        appearance="ghost"
                        icon="trash"
                        className="bt-gost-icon-radius-cancel"
                      />
                    }
                    onClick={() => onClickDelete(item, index)}
                    style={{ marginRight: 5 }}
                  >
                    {'ลบกิจกรรมที่ ' + (index + 1)}
                  </IconButton>
                </div>
              )}
              <br />
            </div>
          )
        })}
      </Grid>

      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {'ยืนยันการลบ กิจกรรมที่ ' + (deleteIndex + 1) + ' ' + deleteData?.activity}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              onDelete(deleteData)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={() => {
              setIsdelete(false)
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}
